import * as Effects from 'redux-saga/effects'
import {
  dataForSyncFlushed,
  requestFlushEvents,
  requestFlushRooms,
} from '../../actions/synchronize/flushData'
import { SynchronizeActions } from '../../reducers/synchronize/actionNames'
import flushEvents from './removers/flushEvents'
import flushRooms from './removers/flushRooms'

function* flush() {
  yield Effects.all([
    Effects.put(requestFlushRooms()),
    Effects.put(requestFlushEvents()),
  ])
  yield Effects.all([
    Effects.take(SynchronizeActions.RoomsFlushed),
    Effects.take(SynchronizeActions.EventsFlushed),
  ])
  yield Effects.put(dataForSyncFlushed())
}

export default function* () {
  yield Effects.takeLatest(SynchronizeActions.FlushDataForSync, flush)
  yield Effects.takeLatest(SynchronizeActions.RequestRoomsFlush, flushRooms)
  yield Effects.takeLatest(SynchronizeActions.RequestEventsFlush, flushEvents)
}
